import { cn } from "@/utils/cn";
import { memo } from "react";
import { SmileIcon } from "../smile-icon";
import { SmileShadow } from "../smile-shadow";

interface SmileIconWithShadowProps {
  classNames?: {
    container?: string;
    smileIcon?: string;
    smileShadow?: string;
  };
}

export const SmileIconWithShadow = memo(function SmileIconWithShadow({
  classNames,
}: SmileIconWithShadowProps) {
  return (
    <div className={cn("relative flex h-[168px] w-[168px] justify-center", classNames?.container)}>
      <SmileIcon className={cn("absolute top-0 left-0 z-10", classNames?.smileIcon)} />
      <SmileShadow
        className={cn(
          "absolute right-0 bottom-0 z-0 translate-x-[33%] translate-y-[52%] scale-135",
          classNames?.smileShadow,
        )}
      />
    </div>
  );
});
